export interface RouteConfig {
  path: string;
  displayName: string;
  hasDependentParams: boolean;
  fallbackRoute?: string;
}

export const SITE_ROUTE_CONFIG: Record<string, RouteConfig> = {
  dragonTiles: {
    path: "/dragon-tiles/$siteId",
    displayName: "Dragon Tiles",
    hasDependentParams: false,
  },
  exchanges: {
    path: "/exchanges/$siteId",
    displayName: "Exchanges",
    hasDependentParams: false,
  },
  creativeSphere: {
    path: "/creative-sphere/$siteId",
    displayName: "Creative Sphere",
    hasDependentParams: false,
  },
  blocks: {
    path: "/blocks/$siteId",
    displayName: "Blocks",
    hasDependentParams: false,
  },
  generations: {
    path: "/generations/$siteId",
    displayName: "Generations",
    hasDependentParams: false,
  },
  "generations.new.pilot": {
    path: "/generations/$siteId/new/pilot/$stepId",
    displayName: "New Generation Pilot",
    hasDependentParams: true,
    fallbackRoute: "generations",
  },
  "generations.new.collection": {
    path: "/generations/$siteId/new/collection/$stepId",
    displayName: "New Generation Collection",
    hasDependentParams: true,
    fallbackRoute: "generations",
  },
  skuStore: {
    path: "/sku-store/$siteId",
    displayName: "SKU Store",
    hasDependentParams: false,
  },
  "skuStore.mapping": {
    path: "/sku-store/$siteId/mapping",
    displayName: "SKU Store Mapping",
    hasDependentParams: false,
  },
  "skuStore.detail": {
    path: "/sku-store/$siteId/$skuId",
    displayName: "SKU Product Detail",
    hasDependentParams: true,
    fallbackRoute: "skuStore",
  },
  "skuStore.detail.media": {
    path: "/sku-store/$siteId/$skuId/media",
    displayName: "SKU Media",
    hasDependentParams: true,
    fallbackRoute: "skuStore",
  },
  "skuStore.detail.reviews": {
    path: "/sku-store/$siteId/$skuId/reviews",
    displayName: "SKU Reviews",
    hasDependentParams: true,
    fallbackRoute: "skuStore",
  },
  "skuStore.detail.variants": {
    path: "/sku-store/$siteId/$skuId/variants",
    displayName: "SKU Variants",
    hasDependentParams: true,
    fallbackRoute: "skuStore",
  },
  "skuStore.detail.copy": {
    path: "/sku-store/$siteId/$skuId/copy",
    displayName: "SKU Copy",
    hasDependentParams: true,
    fallbackRoute: "skuStore",
  },
  "skuStore.detail.mapping": {
    path: "/sku-store/$siteId/$skuId/mapping",
    displayName: "SKU Mapping",
    hasDependentParams: true,
    fallbackRoute: "skuStore",
  },
  "skuStore.detail.stories": {
    path: "/sku-store/$siteId/$skuId/stories",
    displayName: "SKU Stories",
    hasDependentParams: true,
    fallbackRoute: "skuStore",
  },
  "skuStore.detail.associations": {
    path: "/sku-store/$siteId/$skuId/associations",
    displayName: "SKU Associations",
    hasDependentParams: true,
    fallbackRoute: "skuStore",
  },
  "skuStore.detail.engagement": {
    path: "/sku-store/$siteId/$skuId/engagement",
    displayName: "SKU Product Engagement",
    hasDependentParams: true,
    fallbackRoute: "skuStore",
  },
  dimensions: {
    path: "/dimensions/$siteId",
    displayName: "Dimensions",
    hasDependentParams: false,
  },
  "dimensions.exchanges": {
    path: "/dimensions/$siteId/exchanges",
    displayName: "Dimensions — Exchanges",
    hasDependentParams: false,
  },
  "dimensions.people": {
    path: "/dimensions/$siteId/people",
    displayName: "Dimensions — People",
    hasDependentParams: false,
  },
  settings: {
    path: "/settings/$siteId",
    displayName: "Settings",
    hasDependentParams: false,
  },
  blastroConnect: {
    path: "/blastro/$siteId/connect",
    displayName: "Blastro",
    hasDependentParams: false,
  },
  docs: {
    path: "/docs/$siteId",
    displayName: "Docs",
    hasDependentParams: false,
  },
  "settings.general": {
    path: "/settings/$siteId/general",
    displayName: "General",
    hasDependentParams: false,
  },
  "settings.billing": {
    path: "/settings/$siteId/billing",
    displayName: "Billing",
    hasDependentParams: false,
  },
  "settings.reporting": {
    path: "/settings/$siteId/reporting",
    displayName: "Reporting",
    hasDependentParams: false,
  },
  people: {
    path: "/people/$siteId",
    displayName: "People",
    hasDependentParams: false,
    fallbackRoute: "people.audiences",
  },
  "people.lists": {
    path: "/people/$siteId/lists",
    displayName: "Lists Page",
    hasDependentParams: false,
  },
  "people.lists.detail": {
    path: "/people/$siteId/lists/$listId",
    displayName: "List Detail",
    hasDependentParams: true,
    fallbackRoute: "people.lists",
  },
  "people.audiences": {
    path: "/people/$siteId/audiences",
    displayName: "Audiences",
    hasDependentParams: false,
  },
  "people.audiences.new": {
    path: "/people/$siteId/audiences/new",
    displayName: "New Audience",
    hasDependentParams: false,
  },
  "people.audiences.exports": {
    path: "/people/$siteId/audiences/exports",
    displayName: "Exports",
    hasDependentParams: false,
  },
  "people.audiences.edit": {
    path: "/people/$siteId/audiences/$audienceId/edit",
    displayName: "Edit Audience",
    hasDependentParams: true,
    fallbackRoute: "people.audiences",
  },
  "people.audiences.members": {
    path: "/people/$siteId/audiences/$audienceId/members",
    displayName: "Audience Members",
    hasDependentParams: true,
    fallbackRoute: "people.audiences",
  },
  "settings.email": {
    path: "/settings/$siteId/email",
    displayName: "Email",
    hasDependentParams: false,
  },
  "settings.recommendationExclusions": {
    path: "/settings/$siteId/recommendation-exclusions",
    displayName: "Recommendation Exclusions",
    hasDependentParams: false,
  },
  "settings.couponCodes": {
    path: "/settings/$siteId/coupon-codes",
    displayName: "Coupon Codes",
    hasDependentParams: false,
  },
  "settings.sites": {
    path: "/settings/$siteId/sites",
    displayName: "Sites",
    hasDependentParams: false,
  },
  "settings.sites.detail": {
    path: "/settings/$siteId/sites/$rjId",
    displayName: "Site",
    hasDependentParams: true,
    fallbackRoute: "settings.sites",
  },
  "settings.accounts": {
    path: "/settings/$siteId/accounts",
    displayName: "Accounts",
    hasDependentParams: false,
  },
  "settings.accounts.detail": {
    path: "/settings/$siteId/accounts/$accountId",
    displayName: "Account",
    hasDependentParams: true,
    fallbackRoute: "settings.accounts",
  },
  "settings.onboarding": {
    path: "/settings/$siteId/onboarding",
    displayName: "Onboarding",
    hasDependentParams: false,
  },
  "settings.copyFrames": {
    path: "/settings/$siteId/copy-frames",
    displayName: "Copy Tiles",
    hasDependentParams: false,
  },
  "settings.blueprints": {
    path: "/settings/$siteId/blueprints",
    displayName: "Blueprint Review",
    hasDependentParams: false,
  },
  "settings.text": {
    path: "/settings/$siteId/text",
    displayName: "Text",
    hasDependentParams: false,
  },
  "settings.featureFlags": {
    path: "/settings/$siteId/feature-flags",
    displayName: "Feature Flags",
    hasDependentParams: false,
  },
  "people.profiles": {
    path: "/people/$siteId/profiles",
    displayName: "Profiles",
    hasDependentParams: false,
  },
  "people.profiles.detail": {
    path: "/people/$siteId/profiles/$profileId",
    displayName: "Profile Detail",
    hasDependentParams: true,
    fallbackRoute: "people.profiles",
  },
  "exchanges.new": {
    path: "/exchanges/$siteId/new",
    displayName: "New Exchange",
    hasDependentParams: false,
  },
  "exchanges.edit": {
    path: "/exchanges/$siteId/$id/edit",
    displayName: "Edit Exchange",
    hasDependentParams: true,
    fallbackRoute: "exchanges",
  },
  "dragonTiles.connectors": {
    path: "/dragon-tiles/$siteId/connectors",
    displayName: "Dragon Tiles Connectors",
    hasDependentParams: false,
  },
  "dragonTiles.connectors.parentTile": {
    path: "/dragon-tiles/$siteId/connectors/$parentTile",
    displayName: "Dragon Tiles Connectors — Parent Tile",
    hasDependentParams: true,
    fallbackRoute: "dragonTiles.connectors",
  },
  "dragonTiles.connectors.frame": {
    path: "/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId",
    displayName: "Dragon Tiles Connectors — Tile",
    hasDependentParams: true,
    fallbackRoute: "dragonTiles.connectors",
  },
  "dragonTiles.parentTile": {
    path: "/dragon-tiles/$siteId/$parentTile",
    displayName: "Parent Tile",
    hasDependentParams: true,
    fallbackRoute: "dragonTiles",
  },
  "dragonTiles.frame": {
    path: "/dragon-tiles/$siteId/$parentTile/tile/$frameId",
    displayName: "Tile",
    hasDependentParams: true,
    fallbackRoute: "dragonTiles",
  },
  "dragonTiles.broadcast.list": {
    path: "/dragon-tiles/$siteId/broadcast/list",
    displayName: "Broadcasts",
    hasDependentParams: false,
  },
  "dragonTiles.broadcastV2.new.email": {
    path: "/dragon-tiles/$siteId/broadcastV2/new/email",
    displayName: "New Email Broadcast",
    hasDependentParams: false,
  },
  "dragonTiles.broadcastV2.new.sms": {
    path: "/dragon-tiles/$siteId/broadcastV2/new/sms",
    displayName: "New SMS Broadcast",
    hasDependentParams: false,
  },
  "dragonTiles.broadcastV2.email": {
    path: "/dragon-tiles/$siteId/broadcastV2/$broadcastId/email",
    displayName: "Email Broadcast",
    hasDependentParams: true,
    fallbackRoute: "dragonTiles.broadcast.list",
  },
  "dragonTiles.broadcastV2.sms": {
    path: "/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms",
    displayName: "SMS Broadcast",
    hasDependentParams: true,
    fallbackRoute: "dragonTiles.broadcast.list",
  },
  "dragonTiles.byoc": {
    path: "/dragon-tiles/$siteId/byoc",
    displayName: "Bring Your Own Content",
    hasDependentParams: false,
  },
  "dragonTiles.byoc.frame": {
    path: "/dragon-tiles/$siteId/byoc/tile/$frameId",
    displayName: "Bring Your Own Content — Tile",
    hasDependentParams: true,
    fallbackRoute: "dragonTiles.byoc",
  },
  "settings.connectors": {
    path: "/settings/$siteId/connectors",
    displayName: "Connectors",
    hasDependentParams: false,
  },
  "settings.connectors.detail": {
    path: "/settings/$siteId/connectors/$connectorId",
    displayName: "Connector",
    hasDependentParams: true,
    fallbackRoute: "settings.connectors",
  },
  "settings.connectors.installed": {
    path: "/settings/$siteId/connectors/installed",
    displayName: "Installed Connectors",
    hasDependentParams: false,
  },
  "connectors.yotpo.install": {
    path: "/connectors/$siteId/yotpo/install",
    displayName: "Yotpo Install",
    hasDependentParams: false,
  },
  "settings.connectors.all": {
    path: "/settings/$siteId/connectors/all",
    displayName: "Installable Connectors",
    hasDependentParams: false,
  },
  assets: {
    path: "/assets/$siteId",
    displayName: "Asset Library",
    hasDependentParams: false,
  },
  "assets.detail": {
    path: "/assets/$siteId/$assetKey",
    displayName: "Asset Detail",
    hasDependentParams: true,
    fallbackRoute: "assets",
  },
  besties: {
    path: "/besties/$siteId",
    displayName: "Besties",
    hasDependentParams: false,
  },
  "besties.reporting": {
    path: "/besties/$siteId/reporting",
    displayName: "Besties Reporting",
    hasDependentParams: false,
  },
  "besties.revenue": {
    path: "/besties/$siteId/revenue",
    displayName: "Besties Revenue",
    hasDependentParams: false,
  },
  "besties.onboarding": {
    path: "/besties/$siteId/onboarding",
    displayName: "Besties Onboarding",
    hasDependentParams: false,
  },
  "besties.onboarding.brand": {
    path: "/besties/$siteId/onboarding/$brandId",
    displayName: "Besties Brand Onboarding",
    hasDependentParams: true,
    fallbackRoute: "besties.onboarding",
  },
  genlab: {
    path: "/genlab/$siteId",
    displayName: "GenLab",
    hasDependentParams: false,
  },
  composeText: {
    path: "/compose-text/$siteId",
    displayName: "Compose Text",
    hasDependentParams: false,
  },
  marketingCalendar: {
    path: "/marketing-calendar/$siteId",
    displayName: "Marketing Calendar",
    hasDependentParams: false,
  },
  "marketingCalendar.new": {
    path: "/marketing-calendar/$siteId/new",
    displayName: "Plan Event",
    hasDependentParams: false,
  },
};

export interface SiteSwitchMatch {
  routeId: string;
  params: Record<string, unknown>;
}

export interface SiteSwitchResolution<T extends SiteSwitchMatch> {
  currentMatch: T;
  routeKey: string | null;
  config: RouteConfig | null;
  targetRouteKey: string | null;
}

const PARAM_SEGMENT = /\$[^/]+/g;

// TanStack route ids look like "/_auth/settings/$siteId/_zeroAdmin/accounts/"
// or "/_auth/besties/$siteId/onboarding_/$brandId": pathless layouts (`_x`)
// and non-nesting suffixes (`x_`) carry no URL segment.
export function normalizeRouteId(routeId: string): string {
  return routeId
    .replace("/_auth", "")
    .replace(/\/_[^/]+/g, "")
    .replace(/_(?=\/|$)/g, "")
    .replace(/\/+$/, "");
}

const ROUTE_ENTRIES = Object.entries(SITE_ROUTE_CONFIG).map(
  ([key, config]) =>
    [
      key,
      config,
      new RegExp(`^${config.path.replace(PARAM_SEGMENT, "\\$[^/]+")}$`),
    ] as const,
);

function findRouteEntry(
  routeId: string,
): readonly [string, RouteConfig] | undefined {
  const normalizedRouteId = normalizeRouteId(routeId);
  return ROUTE_ENTRIES.find(([, , pattern]) => pattern.test(normalizedRouteId));
}

export function getRouteConfigByPath(routeId: string): RouteConfig | null {
  return findRouteEntry(routeId)?.[1] ?? null;
}

export function resolveSiteSwitchRoute<T extends SiteSwitchMatch>(
  matches: readonly T[],
): SiteSwitchResolution<T> | null {
  const siteMatches = matches
    .filter((match) => match.params && "siteId" in match.params)
    .reverse();
  const currentMatch = siteMatches[0];
  if (!currentMatch) {
    return null;
  }

  for (const match of siteMatches) {
    const entry = findRouteEntry(match.routeId);
    if (!entry) {
      continue;
    }
    const [routeKey, config] = entry;
    return {
      currentMatch,
      routeKey,
      config,
      targetRouteKey: config.fallbackRoute ?? routeKey,
    };
  }

  return { currentMatch, routeKey: null, config: null, targetRouteKey: null };
}

export function shouldShowSiteSelector(routeId: string): boolean {
  return getRouteConfigByPath(routeId) !== null;
}
